export default "__VITE_ASSET__Do9tmpNQ__"